import { injectable } from "inversify";
import RouteWrapper, { IRoute } from "./routeInterface";
import { MainLayout } from "../pages/MainLayout";
import { DossierPage } from "../pages/DossierPage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { LoginPage } from "../pages/LoginPage";
import { SideLogginLayout } from "../pages/sideLogginLayout";
import { CreateNewDossierPage } from "../pages/CreateNewDossierPage";
@injectable()
export class DossierRoute implements IRoute {
    routeKey = "dossiers";
    path = "/";
    allowInNavigation = true;
    icon = <DashboardIcon color={ "secondary" } />
registerRoute = (): JSX.Element => {
    return <RouteWrapper 
    key={ this.routeKey }
    route = { this}
    exact path = { this.path }
    layout = { MainLayout }
    component = { DossierPage } > </RouteWrapper>
}
}
@injectable()
export class LoginRoute implements IRoute {
    routeKey = "login";
    path = "/login";
    allowInNavigation = true;
    icon = <DashboardIcon color={"secondary"} />
    registerRoute = (): JSX.Element => {
        return <RouteWrapper
            key={this.routeKey}
            route={this}
            exact path={this.path}
            layout={SideLogginLayout}
            component={LoginPage} > </RouteWrapper>
    }
}

@injectable()
export class NewDossierRoute implements IRoute {
    routeKey = "NewDossier";
    path = "/new-dossier";
    allowInNavigation = true;
    icon = <DashboardIcon color={"secondary"} />
    registerRoute = (): JSX.Element => {
        return <RouteWrapper
            key={this.routeKey}
            route={this}
            exact path={this.path}
            layout={MainLayout}
            component={CreateNewDossierPage} > </RouteWrapper>
    }
}